var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tax)?_c('span',{class:{'has-text-grey': !_vm.tax.active}},[_vm._v(_vm._s(_vm.tax.name)+" "+_vm._s(_vm.rates))]):_c('span',{directives:[{name:"t",rawName:"v-t",value:('tax_settings.no_tax'),expression:"'tax_settings.no_tax'"}],staticClass:"has-text-grey"})
}
var staticRenderFns = []

export { render, staticRenderFns }